/* eslint-disable react/no-unused-prop-types */
import { imgProxyLoader } from '@doltech/utils/lib/image-loader';
import Image from 'next/image';
import * as React from 'react';
import styled from 'styled-components';

import { colorsV2 } from '../colors-v2';
import { AspectRatio } from '../Common/AspectRatio';
import { Typography } from '../DesignSystemV2/Typography';

const Main = styled.div.withConfig({
  componentId: 'BlogCover_Main',
} as any)`
  .cover-description {
    margin-top: 8px;
    color: ${colorsV2.black70};
  }
  .image-editor {
    object-fit: contain;
    width: 100%;
  }
`;

export interface BlogCoverProps {
  text?: string;

  src: string;
  width?: number;
  height?: number;
  alt: string;
}

export const BlogCover = (props: BlogCoverProps) => {
  const { text, src, alt } = props;

  return (
    <Main id="blog-cover">
      <AspectRatio ratio={3 / 2}>
        <Image
          loader={imgProxyLoader}
          objectFit="cover"
          layout="fill"
          className="image-editor"
          alt={alt || 'blog-cover'}
          src={src}
          loading="lazy"
        />
      </AspectRatio>
      {text && (
        <div className="cover-description">
          <Typography.Text variant="regular/16">{text}</Typography.Text>
        </div>
      )}
    </Main>
  );
};
